/**
 * This component base code was taken from 'react-recaptcha-google' lib.
 * It has been tweaked to work with the enterprise version of Google Recaptcha.
 */

import loadRecaptcha from './loadRecaptcha'
import ReCaptcha from './reCaptcha'

export { ReCaptcha, loadRecaptcha }
